import { Select, SelectChangeEvent } from "@mui/material";
import { MenuItem } from "@mui/material";
import { Paper } from "@mui/material";
import React, { Suspense } from "react";
import { useState, useCallback } from "react";
import { Contact } from "../../../../types/contact.type";
import { CustomInput, CustomSelectInput } from "../../../shared/CustomInput";
import ProfileSubHeader from "../profileSubHeader/ProfileSubHeader";

import "./addContacts.css";

const contactLabelOptions = ["Business", "Home", "Mail", "Mobile", "Other"];
const contactTypeOptions = ["E-Mail", "Phone", "Address"];

const AddContacts = (): JSX.Element => {
	const [contact, setContact] = useState<Contact>({
		contact_label: null,
		contact_type: null,
		preferred: null,
		contact_type_alternate: ""
	});

	const handleContactChange = useCallback(
		(event: SelectChangeEvent<string> | React.ChangeEvent<HTMLInputElement>): void => {
			const { name, value } = event.target;
			setContact(
				Object.assign({}, contact, {
					[name]: name === "preferred" ? (value === "Yes" ? true : false) : value
				})
			);
		},
		[contact]
	);

	const handleAddContact = useCallback(async (): Promise<void> => {
		//api call herer
	}, []);

	return (
		<div className="add-contacts paper-form-container">
			<Paper className="theme-border-radius paper-container" elevation={1}>
				<Suspense fallback={<div />}>
					<ProfileSubHeader
						title={"Contact Information"}
						actionButtons={[
							{
								title: "Add",
								callback: handleAddContact
							}
						]}
						style={{
							marginBottom: "0rem"
						}}
					/>
				</Suspense>
				<div className="details-form-container">
					<div className="details-form-row">
						<div className="details-form-label">Contact Label</div>
						<Select
							value={contact.contact_label ? contact.contact_label : ""}
							input={<CustomSelectInput />}
							style={{ width: "100%" }}
							name="contact_label"
							onChange={handleContactChange}
						>
							<MenuItem value={""}>
								<em>None</em>
							</MenuItem>
							{contactLabelOptions.map((option, index) => {
								return (
									<MenuItem value={option} key={index}>
										{option}
									</MenuItem>
								);
							})}
						</Select>
					</div>
					<div className="details-form-row">
						<div className="details-form-label">Contact Type</div>
						<Select
							value={contact.contact_type ? contact.contact_type : ""}
							input={<CustomSelectInput />}
							style={{ width: "100%" }}
							name="contact_type"
							onChange={handleContactChange}
						>
							<MenuItem value="">
								<em>None</em>
							</MenuItem>
							{contactTypeOptions.map((option, index) => {
								return (
									<MenuItem value={option} key={index}>
										{option}
									</MenuItem>
								);
							})}
						</Select>
					</div>
					<div className="details-form-row">
						<div className="details-form-label">Preferred</div>
						<Select
							value={contact.preferred ? (contact.preferred === true ? "Yes" : "No") : ""}
							input={<CustomSelectInput />}
							style={{ width: "100%" }}
							name="preferred"
							onChange={handleContactChange}
						>
							<MenuItem value="">
								<em>None</em>
							</MenuItem>
							<MenuItem value={"Yes"}>Yes</MenuItem>
							<MenuItem value={"No"}>No</MenuItem>
						</Select>
					</div>
					{contact.contact_label === "Other" ? (
						<div className="details-form-row">
							<div className="details-form-label">Contact Label (ALT)</div>
							<Suspense fallback={<div />}>
								<CustomInput value={contact.contact_type_alternate} onChange={handleContactChange} />
							</Suspense>
						</div>
					) : null}
				</div>
			</Paper>
		</div>
	);
};

export default AddContacts;
